import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { RoleNames } from '../../../Config/constants';
import { dataService } from '../../../Services/data/data.service';
import { makeStyles } from "@material-ui/core/styles";
import { Dialog, DialogTitle, DialogContent, DialogActions, Typography, IconButton, TextField, Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { getAuth, sendPasswordResetEmail } from "firebase/auth";
import { X } from 'lucide-react';
import { toast } from 'react-toastify';
import Button from '../../Shared/Buttons/Button';

export default function UserEditDialog({ dialogOpen, closeDialog, ...props }) {
    const classes = useStyles();
    const { t } = useTranslation();

    const [firstName, setFirstName] = useState(null);
    const [firstNameError, setFirstNameError] = useState(null);

    const [surName, setSurName] = useState(null);
    const [surNameError, setSurNameError] = useState(null);

    const [email, setEmail] = useState(null);
    const [emailError, setEmailError] = useState(null);

    const [roles, setRoles] = useState([]);
    const [rolesError, setRolesError] = useState(null);

    const [passwordResetClicked, setPasswordResetClicked] = useState(false);

    const [generalError, setGeneralError] = useState(null);


    useEffect(() => {
        if (props.userToEdit !== undefined && props.userToEdit !== null) {
            var objUserToEdit = JSON.parse(JSON.stringify(props.userToEdit));
            setEmail(objUserToEdit.emailAddress);
            setFirstName(objUserToEdit.firstname);
            setSurName(objUserToEdit.name);
            setRoles(objUserToEdit.roleIds);
        }
    }, []); // eslint-disable-line react-hooks/exhaustive-deps


    const changeFirstName = (e) => {
        setFirstName(e.target.value);
        if (e.target.value.length > 0) {
            setFirstNameError(null);
        }
    }

    const changeSurName = (e) => {
        setSurName(e.target.value);
        if (e.target.value.length > 0) {
            setSurNameError(null);
        }
    }

    const changeEmail = (e) => {
        setEmail(e.target.value);
        if (e.target.value.length > 0 && validateEmail(e.target.value)) {
            setEmailError(null);
        }
    }

    const changeRole = (e) => {
        var intValue = parseInt(e.target.value);
        var arrRoles = JSON.parse(JSON.stringify(roles));
        if (arrRoles.includes(intValue)) {
            //Remove the roleId from the roleArray
            arrRoles = arrRoles.filter(item => item !== intValue);

        } else {
            //Add role to the roleArray
            setRolesError(null);
            arrRoles.push(intValue);
        }
        setRoles(arrRoles);
    }


    const checkFields = () => {
        var disabled = false;
        if (firstName === "" || firstName === null || firstName === undefined) {
            disabled = true;
        }
        if (surName === "" || surName === null || surName === undefined) {
            disabled = true;
        }
        if (email === "" || email === null || email === undefined) {
            disabled = true;
        }

        return disabled;
    }

    const validateEmail = (strEmail) => {// eslint-disable-next-line
        const regex = /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/;
        return regex.test(strEmail);
    }

    const validateFields = () => {
        var validationGood = true;
        if (firstName === "" || firstName === null || firstName === undefined) {
            validationGood = false;
            setFirstNameError(t('userEditDialog.firstNameRequired'));
        }
        if (surName === "" || surName === null || surName === undefined) {
            validationGood = false;
            setSurNameError(t('userEditDialog.surnameRequired'));
        }
        if (email === "" || email === null || email === undefined) {
            validationGood = false;
            setEmailError(t('userEditDialog.emailRequired'));
        } else {
            if (!validateEmail(email)) {
                validationGood = false;
                setEmailError(t('userEditDialog.invalidEmail'));
            }
        }

        if (roles === null || roles === null || roles.length === 0) {
            validationGood = false;
            setRolesError(t('userEditDialog.roleRequired'));
        }



        return validationGood;
    }

    const handleDeactivateUser = () => {
        dataService.checkSubscriptionUserLimitByCompanyId(props.companyId).then((result) => {
            let userLimitReached = result;

            if (userLimitReached && !props.userToEdit.enabled) {
                setGeneralError(t('userEditDialog.userLimitReached'));
            } else {
                var userObject = {
                    enabled: !props.userToEdit.enabled,
                    userId: props.userToEdit.id,
                    updateByUserId: props.userId,
                    companyId: props.companyId
                };

                dataService.changeUserActive(userObject).then(response => {
                    if (response) {
                        window.location.reload();
                    } else {
                        setGeneralError(t('userEditDialog.setUserStateFailed'));
                    }

                }).catch(error => {
                    console.log('Error: ', error)
                    toast.error(t('errors.generic'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });

                });
            }
        }).catch(error => {
            toast.error(t('userEditDialog.checkUserLimitError'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            console.log('Error: ', error);
        });


        // if (!props.userToEdit.enabled && props.userCompanies.find(c => c.id === props.companyId).users.filter(x => x.enabled).length >= props.userCompanies.find(c => c.id === props.companyId).userLimit) {
        //     toast.error(`Can't activate user, the userlimit has been exceeded!`, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });

        // } else {

        // }


    }

    const handleSaveUser = () => {
        if (validateFields()) {
            var userObject = {
                name: surName,
                firstName: firstName,
                email: email,
                fireBaseId: '',
                roles: roles,
                insertedByUserId: props.userId,
                companyId: props.companyId
            };

            dataService.updateUser(userObject).then(response => {
                if (response.success) {
                    toast.success(response.message, { position: toast.POSITION.TOP_CENTER, autoClose: 2000 })
                    window.location.reload();
                } else {
                    toast.error(t('errors.generic'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
                }
            }).catch((error) => {
                console.log('Error: ', error)
                toast.error(t('errors.generic'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });

            });



        }
    }
    const sendNewPasswordMail = () => {
        const auth = getAuth();
        sendPasswordResetEmail(auth, email)
            .then(() => {
                setPasswordResetClicked(true);
                toast.success(t('userEditDialog.resetMailSent', { email }), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            }).catch((error) => {
                const errorCode = error.code;
                const errorMessage = error.message;
                console.log(`ERROR ${errorCode}: ${errorMessage} `)
                toast.error(t('errors.generic'), { position: toast.POSITION.TOP_CENTER, autoClose: 2000 });
            });
    }

    return (

        <Dialog className={classes.dialog}
            open={dialogOpen}
            aria-labelledby="draggable-dialog-title"
            onClose={closeDialog}
            classes={{ paper: classes.dialogPaper }}
        >
            <div className={classes.dialog__head}>
                <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
                    {t('userEditDialog.title')}
                </DialogTitle>
                <button onClick={() => closeDialog()} className={classes.dialog__closeButton}>
                    <X size={19} />
                </button>
            </div>
            <DialogContent className={classes.dialog__contentContainer}>
                <div className={classes.dialog__content}>
                    {generalError &&
                        <div className={classes.errorContainer}>
                            <p className={classes.errorMessage}>{generalError}</p>
                        </div>
                    }
                    <div className={classes.form}>
                        <div className={classes.inputContainer}>
                            <span className={classes.labelText}>{t('userEditDialog.firstName')} *</span>
                            <TextField
                                className={classes.textField}
                                type={"text"}
                                variant="outlined"
                                size="small"
                                onChange={(event) => changeFirstName(event)}
                                value={firstName}
                                fullWidth={true}
                                error={firstNameError !== null}
                                helperText={firstNameError}
                            >
                            </TextField>
                        </div>
                        <div className={classes.inputContainer}>
                            <span className={classes.labelText}>{t('userEditDialog.lastName')} *</span>
                            <TextField
                                className={classes.textField}
                                type={"text"}
                                variant="outlined"
                                size="small"
                                onChange={(event) => changeSurName(event)}
                                value={surName}
                                fullWidth={true}
                                error={surNameError !== null}
                                helperText={surNameError}
                            >
                            </TextField>
                        </div>
                        <div className={classes.inputContainer}>
                            <span className={classes.labelText}>{t('user.email')} *</span>
                            <TextField
                                className={classes.textField}
                                type={"text"}
                                variant="outlined"
                                size="small"
                                disabled
                                error={emailError !== null}
                                helperText={emailError}
                                onChange={(event) => changeEmail(event)}
                                value={email}
                                fullWidth={true}
                            >
                            </TextField>
                        </div>
                        <div className={classes.inputContainer} style={{ display: 'none' }}>
                            <span className={classes.labelText}>{t('userEditDialog.roles')} *</span>
                            <ToggleButtonGroup sx={{ width: '100% !important' }} onChange={(event) => changeRole(event)} value={roles}>
                                {props.roles.map((role, roleIndex) => {
                                    return <ToggleButton key={`toggleRoleIndex_${roleIndex}`} value={role.id} sx={{ width: "33.33%", textWrap: "nowrap", backgroundColor: roles.includes(role.id) && 'var(--color-primary) !important', color: roles.includes(role.id) && 'white !important' }}>{RoleNames.find(x => x.id === role.id).name}</ToggleButton>
                                })}
                            </ToggleButtonGroup>
                            {rolesError !== null && <p style={{ color: '#d32f2f', fontSize: "0.75rem", fontWeight: '400', letterSpacing: '0.03333em', marginLeft: '14px', marginTop: '4px', fontFamily: 'Roboto' }}>{rolesError}</p>}
                        </div>

                        <div className={classes.inputContainer}>
                            <span className={classes.labelText}>{t('userEditDialog.resetPasswordQuestion')}</span>
                            <Button disabled={passwordResetClicked} onClick={() => sendNewPasswordMail()}>{t('userEditDialog.sendResetMail')}</Button>
                        </div>
                    </div>
                </div>
            </DialogContent>
            <DialogActions sx={{ display: 'flex', justifyContent: 'space-between', paddingLeft: '16px', paddingRight: '16px', paddingBottom: "16px" }}>
                <Button variant="outlined" onClick={() => closeDialog()}>{t('common.cancel')}</Button>
                <Box sx={{ display: "flex", gap: "10px" }}>
                    <Button variant={props.userToEdit.enabled ? "destructive" : "primary"} onClick={() => handleDeactivateUser()}>{props.userToEdit.enabled ? t('userEditDialog.deactivateUser') : t('userEditDialog.activateUser')}</Button>

                    <Button disabled={checkFields()} onClick={() => handleSaveUser()}>{t('userEditDialog.saveChanges')}</Button>

                </Box>

            </DialogActions>

        </Dialog>
    );
}


const useStyles = makeStyles(() => ({
    dialog: {
        margin: "auto"
    },

    dialogPaper: {
        width: '500px !important',
        height: 'auto',
        borderRadius: '6px !important',
    },

    dialog__head: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',

        padding: '16px 16px 0px 16px !important',
        marginBottom: '8px !important',
    },

    dialog__title: {
        fontSize: '24px !important',
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'normal',

        padding: '0px !important',
    },

    dialog__closeButton: {
        backgroundColor: '#F5F5F5',
        border: 'none',
        cursor: 'pointer',

        padding: '3px !important',
        height: '25px !important',

        borderRadius: '3px',

        transition: 'all 0.2s',

        '&:hover': {
            backgroundColor: '#D84949',
            color: '#F5F5F5',
        },

        '&:focus-visible': {
            outline: '#4654FB auto 1px',
        },
    },

    dialog__subtitle: {
        fontSize: '16px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: '#0C0E29',

        margin: '0px 0px 16px 0px',
    },

    dialog__contentContainer: {
        padding: '0px 16px !important',
        marginBottom: "16px",

        // remove scrollbar
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',
    },

    dialog__content: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',

        margin: '0px !important',
    },

    errorContainer: {
        width: "100%",
        backgroundColor: "#FDF3F3",

        border: "1px solid #FBE5E5",
        borderRadius: "6px",

        marginBottom: "16px",
        padding: "12px",
    },

    errorMessage: {
        fontSize: "16px",
        color: "#D84949"
    },


    toggleFilter: {
        width: "100%",
        height: "32px",
        boxSizing: "border-box",

        position: "relative",

        display: "flex",
        alignItems: "center",

        backgroundColor: "#DCDCDC",
        borderRadius: "4px",

        padding: "1px",
        marginBottom: "16px",
    },

    toggleFilter__optionButton: {
        height: "100%",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: "6px",

        border: "none",
        borderRadius: "3px",

        color: "#0C0E29",
        backgroundColor: "transparent",

        transition: "all ease-in-out 0.2s",

        zIndex: "1",

        "&:hover": {
            // backgroundColor: "#DCDCDC",
            cursor: "pointer",
        },

    },

    toggleFilter__label: {
        fontFamily: "Lato, sans-serif",
        fontSize: "14px",
        margin: "0",
    },

    toggleSelected: {
        width: "calc(50% - 1px)",
        height: "30px",
        position: "absolute",
        transition: "transform 0.2s",

        backgroundColor: "white",
        borderRadius: "3px"
    },

    errorContainer: {
        width: "100%",
        backgroundColor: "#FDF3F3",

        border: "1px solid #FBE5E5",
        borderRadius: "6px",

        marginBottom: "8px",
        padding: "12px",
    },

    errorMessage: {
        fontSize: "16px",
        color: "#D84949"
    },

    form: {
        width: "100%",

        display: "flex",
        flexDirection: "column",
        gap: "16px",
    },

    inputContainer: {
        display: "flex",
        flexDirection: "column",
        gap: "4px",
    },

}));
